module.exports = __webpack_public_path__ + "ece87fb43bf51f141f8919193cfc4067.svg";